import { useState, FormEvent } from "react";
import { Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { SITE_CONFIG } from "@/data/siteConfig";

interface SearchBarProps {
  onSearch: (postcode: string) => void;
  defaultValue?: string;
  variant?: "hero" | "compact";
}

const SearchBar = ({ onSearch, defaultValue = "", variant = "compact" }: SearchBarProps) => {
  const [postcode, setPostcode] = useState(defaultValue);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (postcode.trim()) onSearch(postcode.trim());
  };

  if (variant === "hero") {
    return (
      <form onSubmit={handleSubmit} className="mx-auto flex w-full max-w-xl flex-col gap-3 sm:flex-row">
        <Input
          name="postcode"
          placeholder={SITE_CONFIG.searchPlaceholder}
          value={postcode}
          onChange={(e) => setPostcode(e.target.value)}
          required
          className="h-12 flex-1 rounded-lg border-2 border-primary/20 bg-card text-base shadow-sm focus-visible:border-primary"
        />
        <Button type="submit" size="lg" className="h-12 px-8 text-base">
          <Search className="mr-2 h-5 w-5" />
          Search
        </Button>
      </form>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="mx-auto flex w-full max-w-2xl gap-3">
      <Input
        name="postcode"
        placeholder={SITE_CONFIG.searchPlaceholder}
        value={postcode}
        onChange={(e) => setPostcode(e.target.value)}
        required
        className="h-11 flex-1"
      />
      <Button type="submit" className="h-11">
        <Search className="mr-2 h-4 w-4" />
        Search
      </Button>
    </form>
  );
};

export default SearchBar;
